export const COLORS = {
  cantaloupe: '#FF8243',
  cantaloupeDark: '#EA6D2E',
  navy: '#1E293B',
  navyDark: '#0F172A',
  teal: '#2DD4BF',
  slate: '#64748B',
};
